import type { ReactNode } from "react";

interface ExplorerBarProps {
  items?: string[];
  rightContent?: ReactNode;
}

export default function ExplorerBar({
  items = ["Arquivo", "Editar", "Ajuda"],
  rightContent,
}: ExplorerBarProps) {
  return (
    <div className="explorer-bar">
      <div>
        {items.map((item) => (
          <span key={item}>{item}</span>
        ))}
      </div>
      {rightContent}
    </div>
  );
}
